// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2e6145ee].el-cascader__search-input {\n  color: white;\n  opacity: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
